export default __webpack_public_path__ + "static/media/1902015_MW_0011_claire_stebbins_honors.5a46a9db.jpeg";